import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const FAQS = [
  {
    q: "What is NOXWAY Formula 100?",
    a: "A wildfire protection gel that encapsulates water in a thermal matrix, creating a hydrated barrier on vegetation and structures against radiant heat and ember strikes.",
  },
  {
    q: "How long does NOXWAY protection last?",
    a: "The gel barrier holds for 24–48 hours after application, then rinses off cleanly with standard hose water — no staining, no residue.",
  },
  {
    q: "How do I apply NOXWAY?",
    a: "Attach the included system to a standard garden hose and spray a continuous coat across rooflines, eaves, decks and surrounding brush before wildfire exposure.",
  },
  {
    q: "Is NOXWAY safe for pets and the environment?",
    a: "Yes. Formula 100 is biodegradable, non-toxic and non-corrosive — safe for soil, pets and surrounding wildlife.",
  },
  {
    q: "How much does NOXWAY cost?",
    a: "One 5kg bag is CA$1,299. Need multiple bags for a larger property? Email sales@noxway.shop for a bulk quote.",
  },
  {
    q: "Does NOXWAY replace an evacuation plan?",
    a: "No. NOXWAY is an additional layer of property defense and must complement — never replace — official evacuation orders and your fire-safety plan.",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-20 lg:py-28 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-12"
        >
          <div className="font-tech text-[11px] tracking-[0.3em] text-[#f97316] uppercase mb-4" data-testid="faq-kicker">
            FAQ
          </div>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-[#17150f]" data-testid="faq-headline">
            Common questions
          </h2>
        </motion.div>

        <div className="divide-y divide-stone-200 border-y border-stone-200" data-testid="faq-list">
          {FAQS.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={item.q}>
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  data-testid={`faq-question-${i}`}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left"
                >
                  <span className="font-display font-semibold text-base sm:text-lg text-[#17150f]">{item.q}</span>
                  <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.25 }}>
                    <Plus size={18} className={open ? "text-[#f97316]" : "text-stone-400"} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 text-sm sm:text-base text-stone-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
